const gridPaintHandler = (mutation, observer, gridState, measureHandlerProps) => {
    const { selectedReport, handler } = measureHandlerProps;
    if (!gridState || !mutation) {
        return;
    }
    const divElement = mutation.target;
    const parentElement = divElement?.parentElement;

    if (parentElement?.classList?.contains('ag-body-viewport')) {
        if (!selectedReport) {
            return;
        }

        gridState.numOfContainers = Array.from(divElement.parentElement.children).filter(child => {
            return !child?.classList.contains('ag-hidden') && !child?.classList.contains('ag-full-width-container');
        })?.length;
    }

    let paintingFinished = false;
    if (!parentElement?.classList.contains('ag-row-last')) {
        return;
    }

    const colId = divElement.getAttribute('col-id');
    if (!colId || !selectedReport || !colId.includes(selectedReport)) {
        return;
    }
    const children = Array.from(parentElement.children);
    const emptyCell = children.some(child => {
        const hasEmptyInnerHTML = child.innerHTML === '';
        if (hasEmptyInnerHTML) {
            return true;
        }
        const hasReactContainer = child?.classList.contains('ag-react-container');
        const hasNoChildren = child.children.length === 0;
        if (hasReactContainer) {
            return hasNoChildren;
        }
        const lastLeftCell = child.classList.contains('ag-cell-last-left-pinned');
        if (lastLeftCell) {
            paintingFinished = true;
        }
        return false;
    });
    if (emptyCell) {
        return;
    }
    gridState.renderContainer++;
    if (gridState.renderContainer === gridState.numOfContainers || paintingFinished) {
        observer.disconnect();
        if (!gridState.done) {
            gridState.done = true;
            handler();
        }
    }
};

export const observeGridPainted = measureProps => {
    const gridState = {
        renderContainer: 0,
        numOfContainers: 0,
    };
    const observer = new MutationObserver((mutations, observer) => {
        mutations.forEach(mutation => gridPaintHandler(mutation, observer, gridState, measureProps));
    });
    const observerSelector = document.querySelector('.ag-root-wrapper-body');
    if (observerSelector) {
        observer.observe(observerSelector, { childList: true, subtree: true });
        return () => {
            try {
                observer.disconnect();
            } catch {}
        };
    }
};
